var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfferZone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 49,
    viewBox: "0 0 43 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_225)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1201 2.10726V3.50795C15.1201 5.39947 16.0419 7.0755 16.3891 8.55999C17.3708 8.29661 20.8905 4.32202 20.8905 2.65796V1.81994C20.8905 0.742496 18.544 -0.0117188 17.2391 -0.0117188H16.9638C15.9342 0.000252908 15.1201 1.01784 15.1201 2.10726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52344 7.72154V8.28421C8.52344 9.24194 9.68469 9.82856 10.6304 9.82856L11.0614 9.92433L15.4071 9.26589C15.1078 8.16449 12.103 4.9082 10.6304 4.9082H10.4868C9.39737 4.92017 8.52344 6.60818 8.52344 7.72154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0586 8.57205L21.5966 13.3607L30.6112 8.69177L28.0134 3.86719L19.0586 8.57205Z",
    fill: "#FFBB0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4316 10.4397L17.826 15.372L20.6273 13.8995L18.0774 9.13477L15.4316 10.4397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66309 15.6355L8.24896 20.3882L16.8805 15.827L14.3904 11.0264L5.66309 15.6355Z",
    fill: "#FFBB0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6309 31.7372C11.4689 31.7133 12.5224 31.1746 13.5759 31.1746L15.1442 31.0668L19.2026 31.8809V20.5078H10.6309V31.7372Z",
    fill: "#FFBB0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3281 32.0246C20.3281 32.6471 22.3513 32.8626 23.1415 32.8626H23.5605V20.5078H20.3281V32.0246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.906 44.2351C29.0912 44.2351 35.1249 40.0689 36.2383 39.2189C37.8186 38.0218 38.4052 37.4112 39.5904 35.831C39.9735 35.3281 42.3798 32.3592 42.3798 32.012C42.3798 31.5571 41.865 31.3057 41.3981 31.3057H40.6918C38.5249 31.3057 36.5975 34.55 35.1609 35.6035C34.3588 36.2021 32.8862 36.7647 31.8926 37.2556C30.4201 37.9739 30.3722 38.8957 28.6124 38.8957H18.7836C18.4604 38.8957 18.221 38.6682 18.221 38.333V38.1894C18.221 37.4591 20.5674 37.7704 21.3096 37.7704C22.435 37.7704 23.5603 37.7704 24.6857 37.7704C26.6849 37.7704 30.1687 38.4168 30.1687 36.3697C30.1687 33.7599 25.2603 34.4422 22.9498 34.0352C20.1245 33.5324 17.9576 32.2993 15.2759 32.2993H14.1506C12.0675 32.2993 7.29084 34.0711 5.86621 34.8253L10.4035 44.2111L27.906 44.2351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6738 33.0062H25.0928C27.7027 33.0062 31.2223 33.7485 31.2702 36.2386L33.2216 35.3527L33.2455 20.5078H24.6738V33.0062Z",
    fill: "#FFBB0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29709 48.9996L10.3196 46.9884L4.15417 33.8555L0 35.8547L6.29709 48.9996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3797,
    height: 49,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferZone);
export default __webpack_public_path__ + "static/media/offer-zone.e47f709995c7740615088ed6cd5a7100.svg";
export { ForwardRef as ReactComponent };